var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#616674",
    fillRule: "evenodd",
    d: "M5.333 8v1.778H3.556V8h1.777M8.89 8v1.778H7.11V8H8.89m3.555 0v1.778h-1.777V8h1.777m1.778-6.222c.982 0 1.778.796 1.778 1.778V16c0 .982-.796 1.778-1.778 1.778H1.778C.79 17.778 0 16.978 0 16V3.556c0-.982.796-1.778 1.778-1.778h.889V0h1.777v1.778h7.112V0h1.777v1.778h.89m0 14.222V6.222H1.777V16h12.444m-8.889-4.444v1.777H3.556v-1.777h1.777m3.556 0v1.777H7.11v-1.777H8.89m3.555 0v1.777h-1.777v-1.777h1.777z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMonth);
export default __webpack_public_path__ + "static/media/calendar-month.8bb88288acba80febf2406579a3cb2b1.svg";
export { ForwardRef as ReactComponent };